import { Logger } from '_common/services';
import { Command } from '../../Command';

export class RenameDocumentStyleCommand extends Command {
  private options: Editor.Edition.StylesCommandOptions;
  private styleToUpdate: string;
  private newName: string;

  constructor(
    context: Editor.Edition.Context,
    styleId: string,
    newName: string,
    options: Editor.Edition.StylesCommandOptions = {},
  ) {
    super(context);
    this.styleToUpdate = styleId;
    this.newName = newName;
    this.options = {
      applySelection: false,
      createPatch: true,
      untrackedActionWarning: true,
      ...options,
    };
  }

  async renameDocumentStyle() {
    const stylesController = this.context.DataManager?.styles;
    if (!stylesController) {
      return false;
    }

    if (stylesController.documentStyles.doesStyleNameExists(this.newName)) {
      Logger.captureMessage(`Style name already exists: ${this.newName}`);
      return false;
    }

    // update style name
    await stylesController.renameDocumentStyle(this.styleToUpdate, this.newName);

    // notify???
    this.context.notifier({
      variant: 'success',
      title: 'PARAGRAPH_STYLE_RENAMED_TITLE',
      message: 'PARAGRAPH_STYLE_RENAMED_MESSAGE',
      messageValues: { value: this.newName },
    });

    return true;
  }

  protected async handleExec(...args: any[]): Promise<void> {
    if (this.context.debug) {
      Logger.trace('RenameDocumentStyleCommand exec', this);
    }

    if (this.options.untrackedActionWarning && !this.askUserAboutThis()) {
      return;
    }

    this.buildActionContext();

    if (!this.actionContext) {
      throw new Error('Context is not defined');
    }

    if (!(await this.renameDocumentStyle())) {
      return;
    }

    //trigger seelction check
    this.checkSelectionStatus();

    if (this.options.createPatch) {
      this.createPatch();
    }
  }
}
